import React, {Component} from 'react';

import {connect} from 'react-redux'
import Loader from '../Components/Loader';
import * as productSearchActions from '../actions/productSearchActions'
import InfiniteScroll from 'react-infinite-scroller';
import ListingProducts from '../Components/ListingProducts';

class SearchProducts extends Component {

    constructor(props) {
        super(props);
        this.loadMore = this.loadMore.bind(this);
    }

    load(props = null) {
        if(!props){
            props = this.props
        }
        props.searchProducts(props.match.params.keyword, props.match.params.categoryId, '');
        try{
            setTimeout(() => {
                this.refs.productsList.scrollIntoView({behavior: "smooth",block:    "start"})
            },300)
        }catch(err){
            console.log(err)
        }
    }

    componentDidMount() {
        this.load()
    }


    componentWillReceiveProps(nextProps){
        if(nextProps.location.pathname !== this.props.location.pathname){
            this.load(nextProps)
        }
    }

    loadMore(event) {
        if (!this.props.productSearch.has_more || this.props.productSearch.is_loading) {
            return;
        }
        let page = this.props.productSearch.pagination.page + 1;
        this.props.searchProducts(this.props.match.params.keyword, this.props.match.params.categoryId, page);
    }

    render() {
        return (
            <div ref="productsList" className="xxxs">
            <Loader completed={this.props.productSearch.fetchingProducts} >
                <div >
                    <InfiniteScroll

                        pageStart={0}
                        initialLoad={false}
                        loadMore={this.loadMore}
                        hasMore={this.props.productSearch.has_more === true}
                        loader={<div><Loader completed={this.props.productSearch.is_loading === false} /></div>} >

                        <ListingProducts
                            match={this.props.match}
                            products={this.props.productSearch.products}
                            category={this.props.productSearch.category} />

                    </InfiniteScroll>
                </div>

            </Loader>
            </div>
        );
    }
}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth,
        productSearch: state.productSearch,
        modalProduct: state.findProduct,
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        searchProducts: (keyword, categoryId, scrollId) => dispatch(productSearchActions.fetchProducts(keyword, categoryId, scrollId)),
        updateKeyword: (keyword) => dispatch(productSearchActions.updateKeyword(keyword))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchProducts);
